import { render, staticRenderFns } from "./AdditionalSlides.vue?vue&type=template&id=9b9a729e&"
import script from "./AdditionalSlides.vue?vue&type=script&lang=js&"
export * from "./AdditionalSlides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports